import * as React from 'react';
import { useAccountPositionsHistoryHisMvtCmtConsult } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountsPositionsHistoryHisMvtCmtConsult = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsHistoryHisMvtCmtConsult();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue="-------- ---- ----------------"
    />
  );
};
